import { render, staticRenderFns } from "./TotalAcessosDash.vue?vue&type=template&id=6bbc66e7"
import script from "./TotalAcessosDash.vue?vue&type=script&lang=js"
export * from "./TotalAcessosDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports